import React, { useEffect } from 'react'
import oops from 'assets/images/403-Oops-image1.svg';
import { useDispatch } from 'react-redux';
import { handleNotFound } from 'redux/counterSlice';

const NotFoundPage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(handleNotFound(true))
    }, [])
    return (
        <div className="p-5 content-wrapper">
            {/* <div className='access-denied'>
                <img src={oops} alt='Oops' />
                <h2 className='text-center m-4'>Access Denied</h2>
                <p className='m-0'>We're sorry, but it seems that you don't have the necessary permissions to access this content.</p>
                <p>If you believe this is an error, please contact our support team for assistance.</p>
                <p className='mt-3'>Thank you for your understanding.</p>
            </div> */}
            <div className='access-denied'>
                <h2 className='mb-2'>Oops!</h2>
                <p className='text-danger mb-4'>Sorry, you don’t have permission to view this page.</p>
                <img className='img-fluid' src={oops} alt='Oops' />
            </div>
        </div>
    )
}

export default NotFoundPage